var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _vm.formElements
        ? _c(
            "b-row",
            _vm._l(_vm.formElements, function(element, i) {
              return _c(
                "b-col",
                { key: i, attrs: { cols: "6" } },
                [
                  element.ColumnType === "Select" && element.Visible
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "form-group--error":
                              _vm.$v.form[element.EntityProperty].$error
                          },
                          attrs: {
                            label:
                              element.Label +
                              (element.Required === true ? " *" : "")
                          }
                        },
                        [
                          element.modelControlUtil.InputType === "AutoComplete"
                            ? _c(
                                "div",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      readonly: !element.Enabled
                                    },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.onAutoCompleteSearch(
                                          element,
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form[element.EntityProperty],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          element.EntityProperty,
                                          $$v
                                        )
                                      },
                                      expression: "form[element.EntityProperty]"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _vm.searchItems
                ? _c("b-table", {
                    ref: "selectableTable",
                    attrs: {
                      items: _vm.searchItems,
                      "select-mode": "multi",
                      selectable: "",
                      "sticky-header": ""
                    },
                    on: { "row-selected": _vm.onRowSelected },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "head()",
                          fn: function(data) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(data.label)) +
                                  "\n        "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(selected)",
                          fn: function(ref) {
                            var rowSelected = ref.rowSelected
                            return [
                              rowSelected
                                ? [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("✓")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Selected")
                                    ])
                                  ]
                                : [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v(" ")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Not selected")
                                    ])
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3637844502
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.formActions
        ? _c(
            "div",
            { staticClass: "element-modal-footer text-right" },
            _vm._l(_vm.formActions, function(action, i) {
              return _c(
                "b-button",
                {
                  key: i,
                  attrs: {
                    size: "md",
                    variant: action.Action === "Approve" ? "success" : "danger"
                  },
                  on: {
                    click: function($event) {
                      return _vm.save(action)
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(action.Title) + "\n    ")]
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f1095c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1095c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/UpdateModalElements.vue
// module id = null
// module chunks = 